module.exports = __webpack_public_path__ + "img/ic_foot_hight_6.7bb5ab86.png";